import { observer } from "mobx-react-lite";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { CollectionViewPageListEmpty } from "@/pages/collections-view/components/collections-view-page-list-empty";
import { VirtualizedItemList } from "@/components/item-list";
import { useEffect } from "react";

export const CollectionsViewPageList = observer(() => {
  const page = useTabPageStore("collectionsViewPage");
  const collection = page.collectionObservable;

  page.listState.useListStateEffects();

  const handleEndReached = () => {
    if (page.itemRows.length < page.filters.params.limit) return;
    page.filters.increaseLimit();
  };

  useEffect(() => {
    const addToRecents = async () => {
      if (!collection) return;
      await collection.addToRecents();
    };

    addToRecents();
  }, [collection]);

  if (!collection) return null;
  if (page.hasNoItems) {
    return <CollectionViewPageListEmpty />;
  }

  return (
    <>
      <VirtualizedItemList
        enableArrowHighlightNavigation={true}
        enableHighlightedItemPreview={true}
        onOpenHighlightedItem={({ itemId, event }) => {
          if (!page.orderedItemIds.includes(itemId)) {
            return;
          }

          page.store.navigation.goToNote({ noteId: itemId, event });
        }}
        rows={page.itemRows}
        listState={page.listState}
        scrollTop={page.scrollTop}
        endReached={handleEndReached}
        setScrollTop={page.setScrollTop}
      />
      {page.listState.multiSelectUi}
    </>
  );
});
